import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-primary-900 bg-primary-950">
      <div className="w-full px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 font-heading text-lg font-bold text-background-50">
                亚
              </span>
              <div className="flex flex-col leading-none">
                <h3 className="font-heading text-base font-bold text-foreground-50">亚洲激情视频</h3>
                <span className="mt-1 text-[9px] uppercase tracking-[0.3em] text-primary-300">
                  Asia Passion
                </span>
              </div>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-300">
              专业的亚洲影像内容聚合平台，提供分类浏览、条件筛选与详情资料，帮助成年观众快速找到感兴趣的内容。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="rounded-full border border-primary-800 px-2.5 py-1 text-[11px] text-primary-200">
                成人内容提示
              </span>
              <span className="rounded-full border border-primary-800 px-2.5 py-1 text-[11px] text-primary-200">
                全站演示数据
              </span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-100">内容分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-y-2.5">
              {categories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="text-sm text-foreground-400 transition-colors hover:text-primary-200"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-100">站点导航</h3>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 transition-colors hover:text-primary-200">
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/night"
                  className="text-sm text-foreground-400 transition-colors hover:text-primary-200"
                >
                  分类总览
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-foreground-400 transition-colors hover:text-primary-200">
                  视频搜索
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 transition-colors hover:text-primary-200">
                  关于与联系
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-foreground-100">免责声明</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-400">
              本站所有视频标题、简介与封面均为虚构示例，仅用于界面功能演示，不对应任何真实人物或作品。站内不提供真实视频流播放服务，播放、搜索与分享功能均为前端模拟。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-400">
              本站面向 18 岁以上成年用户。如您未满法定年龄，请立即离开本站。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 亚洲激情视频 · 内容聚合演示站点</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>示例内容 · 不涉及真实人物资料</span>
            <span className="hidden sm:inline text-primary-800">|</span>
            <span>18+ 成人内容提示</span>
          </p>
        </div>
      </div>
    </footer>
  );
}